module.exports = __webpack_public_path__ + "static/media/prescription-bottle.593e9fbf.png";